(function (window,$) {
    dustars.theme = [];
    dustars.theme.msg = [];
    Dustars.Theme = {};
    
}(window,jQuery));
